export const queries = {
  accountExecutives: 'accountExecutives',

  adminAdvancePayorShow: 'adminAdvancePayorShow',
  adminAdvancePayors: 'adminAdvancePayors',
  adminAdvanceRelationship: 'adminAdvanceRelationship',
  adminBankAccountRejectionTypes: 'adminBankAccountRejectionTypes',
  adminBrokerAccountMatchingsRecentConflictTotal: 'adminBrokerAccountMatchingsRecentConflictTotal',
  adminBrokerAccountMatchingsRecentMatchTotal: 'adminBrokerAccountMatchingsRecentMatchTotal',
  adminBrokerAccountMatchingsTotal: 'adminBrokerAccountMatchingsTotal',
  adminBrokerCarrierMatchingsRecentConflictTotals: 'adminBrokerCarrierMatchingsRecentConflictTotals',
  adminBrokerCarrierMatchingsRecentMatchTotals: 'adminBrokerCarrierMatchingsRecentMatchTotals',
  adminBrokerCarrierMatchingsTotals: 'adminBrokerCarrierMatchingsTotals',
  adminBulkRemove: 'adminBulkRemove',
  adminCompanies: 'adminCompanies',
  adminCompanyDetails: 'adminCompanyDetails',
  adminCsrSearch: 'adminCsrSearch',
  adminFactorAssignment: 'adminFactorAssignment',
  adminFactorAssignmentRequestShow: 'adminFactorAssignmentRequestShow',
  adminFactorAssignmentRequests: 'adminFactorAssignmentRequests',
  adminFactorAssignmentRequestsHistory: 'adminFactorAssignmentRequestsHistory',
  adminFactorClientMatchingsRecentConflictTotal: 'adminFactorClientMatchingsRecentConflictTotal',
  adminFactorClientMatchingsRecentMatchTotal: 'adminFactorClientMatchingsRecentMatchTotal',
  adminFactorClientMatchingsTotal: 'adminFactorClientMatchingsTotal',
  adminFactorDebtorMatchingsRecentConflictTotal: 'adminFactorDebtorMatchingsRecentConflictTotal',
  adminFactorDebtorMatchingsRecentMatchTotal: 'adminFactorDebtorMatchingsRecentMatchTotal',
  adminFactorDebtorMatchingsTotal: 'adminFactorDebtorMatchingsTotal',
  adminGlobalCarrierFactorWillRelease: 'adminGlobalCarrierFactorWillRelease',
  adminGlobalCarriersSearch: 'adminGlobalCarriersSearch',
  adminInvoices: 'adminInvoices',
  adminInvoicesDateTypes: 'adminInvoicesDateTypes',
  adminInvoicesStatuses: 'adminInvoicesStatuses',
  adminLockNoa: 'adminLockNoa',
  adminLorDesignation: 'adminLorDesignation',
  adminMetricsIncomingNoaCounts: 'adminMetricsIncomingNoaCounts',
  adminMisdirectedPaymentTypes: 'adminMisdirectedPaymentTypes',
  adminMisdirectedPayments: 'adminMisdirectedPayments',
  adminNoaActionConflict: 'adminNoaActionConflict',
  adminNoaActionConflictHistory: 'adminNoaActionConflictHistory',
  adminNoaActionConflicts: 'adminNoaActionConflicts',
  adminNoaCoachables: 'adminNoaCoachables',
  adminNoaLatestPendingFactorRequest: 'adminNoaLatestPendingFactorRequest',
  adminNoaLetterOfReleaseTypes: 'adminNoaLetterOfReleaseTypes',
  adminNoaMatches: 'adminNoaMatches',
  adminNoaPayeeMatches: 'adminNoaPayeeMatches',
  adminNoaPreLockShow: 'adminNoaPreLockShow',
  adminNoaSearch: 'adminNoaSearch',
  adminNoaSearchFactors: 'adminNoaSearchFactors',
  adminNoaSearchPayors: 'adminNoaSearchPayors',
  adminNoaSearchRelationship: 'adminNoaSearchRelationship',
  adminNoaShow: 'adminNoaShow',
  adminNoaSplitNoas: 'adminNoaSplitNoas',
  adminNoaStatuses: 'adminNoaStatuses',
  adminNoaTotals: 'adminNoaTotals',
  adminNoas: 'adminNoas',
  adminPayeeRelationships: 'adminPayeeRelationships',
  adminPayeeShow: 'adminPayeeShow',
  adminPayorCurrencyTypes: 'adminPayorCurrencyTypes',
  adminPayorDocuments: 'adminPayorDocuments',
  adminPayorProfileTypes: 'adminPayorProfileTypes',
  adminPayorShow: 'adminPayorShow',
  adminPayorTierTypes: 'adminPayorTierTypes',
  adminPayorTransferMateSettings: 'adminPayorTransferMateSettings',
  adminPayorTypes: 'adminPayorTypes',
  adminPayors: 'adminPayors',
  adminPayorsDashboard: 'adminPayorsDashboard',
  adminPayorsWillExceedCreditLimit: 'adminPayorsWillExceedCreditLimit',
  adminPromotionalCampaigns: 'adminPromotionalCampaigns',
  adminPromotionalCampaignsPayors: 'adminPromotionalCampaignsPayors',
  adminPromotionalCampaignsRelationships: 'adminPromotionalCampaignsRelationships',

  adminSelectCarrierClaimedRelationships: (id: string) => `adminSelectCarrierClaimedRelationships-${id}`,
  adminSelectCarrierDistinctTmsData: 'adminSelectCarrierDistinctTmsData',
  adminSelectCarrierIndex: 'adminSelectCarrierIndex',
  adminSelectCarrierPotentialRelationships: (id: string) => `adminSelectCarrierPotentialRelationships-${id}`,
  adminSelectCarrierShow: 'adminSelectCarrierShow',
  adminSelectCarrierStatuses: 'adminSelectCarrierStatuses',

  adminShipperAdvances: 'adminShipperAdvances',
  adminShipperAdvancesDateTypes: 'adminShipperAdvanceDateTypes',

  adminTargetBankAccounts: 'adminTargetBankAccounts',
  adminTransactionReverseReasons: 'adminTransactionReverseReasons',

  adminTriumphLoadAdvancePayorShow: 'adminTriumphLoadAdvancePayorShow',
  adminTriumphLoadAdvancePayors: 'adminTriumphLoadAdvancePayors',
  adminTriumphLoadAdvanceRelationship: 'adminTriumphLoadAdvanceRelationship',
  adminTriumphLoadAdvances: 'adminTriumphLoadAdvances',
  adminTriumphLoadAdvancesDateTypes: 'adminTriumphLoadAdvanceDateTypes',

  adminUnmatchedBrokerAccount: 'adminUnmatchedBrokerAccount',
  adminUnmatchedBrokerAccountIds: 'adminUnmatchedBrokerAccountIds',
  adminUnmatchedBrokerCarrier: 'adminUnmatchedBrokerCarrier',
  adminUnmatchedBrokerCarrierIds: 'adminUnmatchedBrokerCarrierIds',
  adminUnmatchedBrokerCarrierRelationships: 'adminUnmatchedBrokerCarrierRelationships',
  adminUnmatchedFactorClient: 'adminUnmatchedFactorClient',
  adminUnmatchedFactorClientIds: 'adminUnmatchedFactorClientIds',
  adminUnmatchedFactorDebtor: 'adminUnmatchedFactorDebtor',
  adminUnmatchedFactorDebtorIds: 'adminUnmatchedFactorDebtorIds',

  adminUnreconciledFundsPayorAccounts: 'adminUnreconciledFundsPayorAccounts',
  adminUnreconciledFundsPayorShow: 'adminUnreconciledFundsPayorShow',
  adminUnreconciledFundsPayors: 'adminUnreconciledFundsPayors',
  adminUnreconciledFundsStatuses: 'adminUnreconciledFundsStatuses',

  adminUsers: 'adminUsers',

  authOAuthInfo: 'authOAuthInfo',
  authTokenExpiration: 'authTokenExpiration',
  authUser: 'authUser',

  bankAllowedTypes: 'bankAllowedTypes',
  bankChangeRequests: 'bankChangeRequests',

  beamerSegments: 'beamerSegments',

  billsAll: 'billsAll',
  billsCanViewPaperwork: 'billsCanViewPaperwork',
  billsChargeTypes: 'billsChargeTypes',
  billsImageTypes: 'billsImageTypes',
  billsIndex: 'billsIndex',
  billsPaperworkTypeShow: 'billsPaperworkTypeShow',
  billsPayors: 'billsPayors',
  billsPresent: 'billsPresent',
  billsShow: 'billsShow',
  billsStatuses: 'billsStatuses',
  billsValidationRulesShow: 'billsValidationRulesShow',

  companyTypes: 'companyTypes',
  coreFeatureFlags: 'coreFeatureFlags',
  countries: 'countries',
  creditLimitExceeded: 'creditLimitExceeded',
  creditLimitExceededCount: 'creditLimitExceededCount',
  creditLimitExposure: 'creditLimitExposure',
  currencyTypes: 'currencyTypes',

  deltaClient: 'deltaClient',
  factorAllInvoicesTable: 'factorAllInvoicesTable',
  factorAllLoadsTable: 'factorAllLoadsTable',
  factorInvoiceDateTypes: 'factorInvoiceDateTypes',
  factorInvoiceStatuses: 'factorInvoiceStatuses',
  factorInvoicesShow: 'factorInvoicesShow',
  factorInvoicesTable: 'factorInvoicesTable',
  factorLoadShow: 'factorLoadShow',
  factorLoadStatuses: 'factorLoadStatuses',
  factorLoadsDateTypes: 'factorLoadsDateTypes',
  factorLoadsTable: 'factorLoadsTable',
  factorPaymentStatuses: 'factorPaymentStatuses',
  factorPaymentsShow: 'factorPaymentsShow',
  factorPaymentsTable: 'factorPaymentsTable',
  factorPayorShow: 'factorPayorShow',
  factorPayorsByName: 'factorPayorsByName',
  factorPayorsTable: 'factorPayorsTable',
  factorRelationshipsByName: 'factorRelationshipsByName',
  factorRelationshipsShow: 'factorRelationshipsShow',
  factorRelationshipsTable: 'factorRelationshipsTable',

  fmcsaByDOT: 'fmcsaByDOT',
  fmcsaByMC: 'fmcsaByMC',
  incomingEFTBanks: 'incomingEFTBanks',
  integrationsProviderName: 'integrationsProviderName',
  invoicePayDateChanged: 'invoicePayDateChanged',
  invoicePayDateChangedShow: 'invoicePayDateChanged',
  metrics: 'metrics',
  metricsHistory: 'metricsHistory',
  noaActionUsers: 'noaActionUsers',
  noaTopCountsBySourceAddress: 'noaTopCountsBySourceAddress',
  notes: 'notes',
  oktaInfo: 'oktaInfo',
  oktaLoginType: 'oktaLoginType',

  payeeActivePromotionalCampaign: 'payeeActivePromotionalCampaign',
  payeeBankAccountStatus: 'payeeBankAccountStatus',
  payeeBankAccountTypes: 'payeeBankAccountTypes',
  payeeDashboardAllBrokers: 'payeeDashboardAllBrokers',
  payeeDashboardMyMoney: 'payeeDashboardMyMoney',
  payeeGlobalSearch: 'payeeGlobalSearch',
  payeeInvoiceDateTypes: 'payeeInvoiceDateTypes',
  payeeInvoiceStatuses: 'payeeInvoiceStatuses',
  payeeInvoicesAndCreditNotes: 'payeeInvoicesAndCreditNotes',
  payeeInvoicesAndCreditNotesShow: 'payeeInvoicesAndCreditNotesShow',
  payeeLinkToLoadPayApplication: 'payeeLinkToLoadPayApplication',
  payeeLoadPayPromotion: 'payeeLoadPayPromotion',
  payeeLoadShow: 'payeeLoadShow',
  payeeLoadsFromBroker: 'payeeLoadsFromBroker',
  payeePayeeRelationships: 'payeePayeeRelationships',
  payeePayeeRelationshipsShow: 'payeePayeeRelationshipsShow',
  payeePayeeRelationshipsShowUnauth: 'payeePayeeRelationshipsShowUnauth',
  payeePaymentStatuses: 'payeePaymentStatuses',
  payeePayments: 'payeePayments',
  payeePaymentsShow: 'payeePaymentsShow',
  payeePayorNames: 'payeePayorNames',
  payeePayors: 'payeePayors',
  payeePayorsByName: 'payeePayorsByName',
  payeePayorsShow: 'payeePayorsShow',
  payeePromotionalCampaigns: 'payeePromotionalCampaigns',
  payeePromotionalInvoicesByCampaign: 'payeePromotionalInvoicesByCampaign',
  payeeQuickPayableInvoices: 'payeeQuickPayableInvoices',
  payeeRelationshipsContactInfo: 'payeeRelationshipsContactInfo',
  payeeSelectCarrierOffer: 'payeeSelectCarrierOffer',
  payeeUnclaimedPayeeRelationships: 'payeeUnclaimedPayeeRelationships',

  paymentFullImages: 'paymentFullImages',
  paymentMethodRequests: 'paymentMethodRequests',

  payorBankAccountDraftRequirements: 'payorBankAccountDraftRequirements',
  payorBankAccountReverseWireDraftRequirements: 'payorBankAccountReverseWireDraftRequirements',
  payorBankAccountSettlementRequirements: 'payorBankAccountSettlementRequirements',
  payorBillingReport: 'payorBillingReport',
  payorCreditLimitReport: 'payorCreditLimitReport',
  payorCreditNoteDateTypes: 'payorCreditNoteDateTypes',
  payorCreditNoteStatuses: 'payorCreditNoteStatuses',
  payorCreditNotesIndex: 'payorCreditNotesIndex',
  payorCreditNotesShow: 'payorCreditNotesShow',
  payorCreditUsage: 'payorCreditUsage',
  payorCurrentSettlement: 'payorCurrentSettlement',
  payorDashboardInsights: 'payorDashboardInsights',
  payorExposures: 'payorExposures',
  payorFactorNames: 'payorFactorNames',
  payorFinanceableInvoicesSummary: 'payorFinanceableInvoicesSummary',
  payorGotpFeesReport: 'payorGotpFeesReport',
  payorHighwayAlerts: 'payorHighwayAlerts',
  payorHighwayAlertsStatuses: 'payorHighwayAlertsStatuses',
  payorHighwaySummary: 'payorHighwaySummary',
  payorInvoiceBatchReviews: 'payorInvoiceBatchReviews',
  payorInvoiceDateTypes: 'payorInvoiceDateTypes',
  payorInvoiceFinanceSummary: 'payorInvoiceFinanceSummary',
  payorInvoiceRefundsReport: 'payorInvoiceRefundsReport',
  payorInvoiceStatuses: 'payorInvoiceStatuses',
  payorInvoicesBulkTerms: 'payorInvoicesBulkTerms',
  payorInvoicesDraftedTomorrow: 'payorInvoicesDraftedTomorrow',
  payorInvoicesIndex: 'payorInvoicesIndex',
  payorInvoicesShow: 'payorInvoicesShow',
  payorList: 'payorList',
  payorLoadStatuses: 'payorLoadStatuses',
  payorLoads: 'payorLoads',
  payorLoadsShow: 'payorLoadsShow',
  payorPayeeNames: 'payorPayeeNames',
  payorPaymentStatuses: 'payorPaymentStatuses',
  payorPayments: 'payorPayments',
  payorPaymentsShow: 'payorPaymentsShow',
  payorPreviousSettlementReport: 'payorPreviousSettlementReport',
  payorProfileSettings: 'payorProfileSettings',
  payorRelationshipCategories: 'payorRelationshipCategories',
  payorRelationshipStatuses: 'payorRelationshipStatuses',
  payorRelationshipsByName: 'payorRelationshipsByName',
  payorRelationshipsIndex: 'payorRelationshipsIndex',
  payorRelationshipsShow: 'payorRelationshipsShow',
  payorRelationshipsTop: 'payorRelationshipsTop',
  payorRevenueShareReport: 'payorRevenueShareReport',
  payorTasks: 'payorTasks',
  payorTerms: 'payorTerms',
  payorUnreconciledFunds: 'payorUnreconciledFunds',
  pendingCarrierBanksIndex: 'pendingCarrierBanksIndex',
  pendingCarrierBanksShow: 'pendingCarrierBanksShow',
  pendingCarrierBanksSummary: 'pendingCarrierBankSummary',
  previousCarrierBankReviews: 'previousCarrierBankReviews',
  selectCarrierDefaultRate: 'selectCarrierDefaultRate',
  user: 'user',
  userNotifications: 'userNotifications',
  userRoles: 'userRoles',
  users: 'users',
  usersNotifications: 'usersNotifications',
} as const;
